import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { Router, RouterLink } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiServiceService } from '../api-service.service';
import { CommonPaginationComponent } from '../common-component-pagination/common-component-pagination.component';
import { CommonSearchComponent } from '../common-component-search/common-component-search.component';
@Component({
  selector: 'app-device-model-list',
  templateUrl: './device-model-list.component.html',
  styleUrls: ['./device-model-list.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatIcon,
    MatTooltip,
    NgxPaginationModule,
    CommonSearchComponent,
    RouterLink,
    CommonPaginationComponent,
  ],
})
export class DeviceModelListComponent implements OnInit {
  modelForm: FormGroup = this.formBuilder.group({});

  size = 10;
  page = 1;
  totalLength = 0;
  searchText = '';
  modelList = [];

  userPermission = [];
  loggedId = '';

  ModelFirmwareView = false;
  ModelFirmwareCreate = false;
  ModelFirmwareDelete = false;

  constructor(
    public apiMicroservice: ApiServiceService,
    private formBuilder: FormBuilder,
    public router: Router,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.setModelPageForm();
    this.checkPermission();
    if (this.ModelFirmwareView) {
      this.fetchModelList();
    }
  }

  checkPermission() {
    this.loggedId = this.apiMicroservice.decryptData(
      sessionStorage.getItem('userRefId') || ''
    );
    this.userPermission = JSON.parse(
      this.apiMicroservice.decryptData(
        sessionStorage.getItem('userPermission') || '[]'
      )
    );
    this.userPermission.forEach(
      (element: {
        pageName: string;
        view: boolean;
        create: boolean;
        delete: boolean;
        update: boolean;
      }) => {
        if (element.pageName === 'Device Model' && element.view === false) {
          this.navigateBack();
        }
        if (element.pageName === 'Device Model' && element.update === true) {
          this.ModelFirmwareView = true;
        }
        if (element.pageName === 'Device Model' && element.create === true) {
          this.ModelFirmwareCreate = true;
        }
        if (element.pageName === 'Device Model' && element.delete === true) {
          this.ModelFirmwareDelete = true;
        }
      }
    );
  }

  setModelPageForm() {
    this.modelForm = this.formBuilder.group({
      modelListSearch: new FormControl(''),
    });
  }

  fetchModelList() {
    this.spinner.show();
    this.apiMicroservice
      .getFirmwareList(this.page, this.size, this.searchText)
      .subscribe((res) => {
        this.modelList = res.data.data;
        this.totalLength = res.data.totalItems;
        if (res.status) {
          this.apiMicroservice.openSnackbar(res.message);
        } else {
          this.apiMicroservice.openSnackbar(res.message);
        }
        this.spinner.hide();
      });
  }

  prePopulation(id) {
    this.router.navigate(['device-model-details', id]);
  }

  delete(id) {
    if (confirm('Are you Sure?')) {
      this.spinner.show();
      this.apiMicroservice.deleteFirmware(id).subscribe({
        next: (res) => {
          if (res.status) {
            this.apiMicroservice.openSnackbar(res.message);
          } else {
            this.apiMicroservice.openSnackbar(res.message);
          }
          this.ngOnInit();
          this.spinner.hide();
        },
        error: (error) => {
          this.spinner.hide();
          this.apiMicroservice.openSnackbar(error.error.message);
        },
      });
    }
  }

  AddNew() {
    this.router.navigate(['device-model-details']);
  }

  onPageChange(event: number) {
    this.page = event;
    this.fetchModelList();
  }

  onSizeChange(event: number) {
    this.page = 1;
    this.size = event;
    this.fetchModelList();
  }

  onSearch(event: string) {
    this.page = 1;
    this.searchText = event;
    this.modelForm
      ?.get('modelListSearch')
      ?.setValue(this.searchText ? this.searchText : '');
    this.fetchModelList();
  }

  navigateBack() {
    this.apiMicroservice.back();
  }
}
